import {
	JobTitleScreeningItem,
	JobTitleScreeningList,
	jobTitleScreeningListSchema,
	jobTitleScreeningPrefillResultSchema,
	jobTitleScreeningSchema,
	JobTitleScreeningPrefillResult,
	JobTitleVerdict,
} from "@signalist/shared-types";

import { z } from "zod";

import { api } from "@/redux/api";

/** How many titles the tab loads per verdict; search covers anything beyond it (PREC-3536). */
export const JOB_TITLE_PAGE_SIZE = 200;

export interface GetJobTitlesParams {
	searchValue?: string;
	page?: number;
	limit?: number;
}

export interface AddJobTitlesParams {
	titles: string[];
	verdict: JobTitleVerdict;
}

export interface MoveJobTitlesParams {
	ids: number[];
	toVerdict: JobTitleVerdict;
}

const jobTitleRowListSchema = z.array(jobTitleScreeningSchema);

export const jobTitleScreeningApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getJobTitles: builder.query<JobTitleScreeningList, GetJobTitlesParams>({
			query: ({ searchValue, page = 1, limit = JOB_TITLE_PAGE_SIZE }) => ({
				url: "score/job-title-screening",
				params: {
					page,
					limit,
					...(searchValue ? { searchValue } : {}),
				},
				responseSchema: jobTitleScreeningListSchema,
			}),
			providesTags: ["JobTitleScreening"],
		}),
		addJobTitles: builder.mutation<JobTitleScreeningItem[], AddJobTitlesParams>({
			query: (body) => ({
				url: "score/job-title-screening",
				method: "POST",
				body,
				responseSchema: jobTitleRowListSchema,
			}),
			invalidatesTags: ["JobTitleScreening"],
		}),
		moveJobTitles: builder.mutation<JobTitleScreeningItem[], MoveJobTitlesParams>({
			query: (body) => ({
				url: "score/job-title-screening/move",
				method: "PATCH",
				body,
				responseSchema: jobTitleRowListSchema,
			}),
			invalidatesTags: ["JobTitleScreening"],
		}),
		deleteJobTitle: builder.mutation<{ message: string }, number>({
			query: (id) => ({
				url: `score/job-title-screening/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["JobTitleScreening"],
		}),
		prefillJobTitles: builder.mutation<JobTitleScreeningPrefillResult, void>({
			query: () => ({
				url: "score/job-title-screening/prefill",
				method: "POST",
				responseSchema: jobTitleScreeningPrefillResultSchema,
			}),
			invalidatesTags: ["JobTitleScreening"],
		}),
	}),
});

export const {
	useGetJobTitlesQuery,
	useAddJobTitlesMutation,
	useMoveJobTitlesMutation,
	useDeleteJobTitleMutation,
	usePrefillJobTitlesMutation,
} = jobTitleScreeningApi;
